import { render } from "./SearchGuide.vue?vue&type=template&id=2b9eeb86&scoped=true"
import script from "./SearchGuide.vue?vue&type=script&lang=js"
export * from "./SearchGuide.vue?vue&type=script&lang=js"

import "./SearchGuide.vue?vue&type=style&index=0&id=2b9eeb86&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9eeb86"]])

export default __exports__